export default "__VITE_ASSET__COg$bUax__"